import { render, staticRenderFns } from "./CurrencySummaryCard.vue?vue&type=template&id=56183379&scoped=true"
import script from "./CurrencySummaryCard.vue?vue&type=script&lang=js"
export * from "./CurrencySummaryCard.vue?vue&type=script&lang=js"
import style0 from "./CurrencySummaryCard.vue?vue&type=style&index=0&id=56183379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56183379",
  null
  
)

export default component.exports